import { authenticatedFetch } from '../../api/request';

export default async function getUserProfile( userType, userId, setErrorMessage) {
    const onError = () => setErrorMessage('No fue posible obtener la información de usuario. Inténtelo de nuevo.');

    return await authenticatedFetch(`/${userType === 'patient' ? 'auth' : 'doctor-data'}/user-profile/${userId}`, onError);
}
